import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import * as Sentry from "@sentry/vue";

import axios from "axios";
import VueAxios from "vue-axios";

import ElementUI from "element-ui";
import { Button, Input, Form, Alert, FormItem } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import "./assets/css/inter.css";
import VueCodeHighlight from "vue-code-highlight";

import { createPinia, PiniaVuePlugin } from "pinia";

Vue.use(PiniaVuePlugin);
const pinia = createPinia();
import configService from "./services/config";
import LaunchDarklyPlugin from "./plugins/launchdarkly.js";

import loaderPlugin from "./plugins/loaderPlugin.js";
Vue.use(loaderPlugin, {
  store,
});

import notificationPlugin from "./plugins/notificationPlugin.js";
Vue.use(notificationPlugin);

Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.component(Button.name, Button);
Vue.component(Input.name, Input);
Vue.component(Form.name, Form);
Vue.component(Alert.name, Alert);
Vue.component(FormItem.name, FormItem);
Vue.use(VueAxios, axios);
Vue.use(VueCodeHighlight);

Vue.use(LaunchDarklyPlugin);

async function initializeApp() {
  try {
    await configService.load();
    configService.loadSecureConfigFromStorage();
    Vue.prototype.$config = configService;

    const DSN_URL = configService.get("dsnUrl");
    const ENVIRONMENT = configService.get("environment");

    if (DSN_URL) {
      Sentry.init({
        Vue,
        dsn: DSN_URL,
        sendDefaultPii: true,
        environment: ENVIRONMENT,
      });
    }
  } catch (error) {
    console.error("Application initialization failed:", error);
  }

  new Vue({
    router,
    store,
    vuetify,
    pinia,
    render: (h) => h(App),
  }).$mount("#app");
}

initializeApp();
